import { collection, doc,onSnapshot, query, updateDoc } from "firebase/firestore";
import { db } from "../config/firebase";

export const QueryDisabledHidden = (setData, round = undefined) => {
    try {
        const q1 = query(collection(db, 'disabledHidden'))
        return onSnapshot(q1, querySnapshot => {
            let d = {}
            querySnapshot.forEach(doc => {
                if (!isNaN(round) && String(round) === String(doc.id)) {
                    d = {...d, [doc.id] : {...doc.data()}}
                }
                else if (isNaN(round)) {
                    d = {...d, [doc.id] : {...doc.data()}}
                }
            })
            setData(d)
        })
    }
    catch (e) {
        console.log(e)
    }
}

export const UpdateSettingDisabledHidden = async (isChecked, round, field, obj) => {
    try {
        const docRef = doc(db, "disabledHidden", String(round));
        await updateDoc(docRef, {
            [`${field}.${obj}`] : isChecked
        });
    }
    catch (e) {
        console.log(e)
    }
}
